import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import YourQuestionsAnsweredTextBlock from 'src/app/organisms/Homepage/YourQuestionsAnsweredTextBlock/YourQuestionsAnsweredTextBlock';

const YourQuestionsAnswered = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
  >
    <YourQuestionsAnsweredTextBlock />
  </SectionLayout>
);

export default YourQuestionsAnswered;
